<template>
  <div class="contact-info">
    <div class="grid grid--large">
      <div
        v-if="$store.state.gaps[dateToday] && $store.state.gaps[dateTomorrow]"
        class="grid__item"
      >
        <section class="card contact-info__card">
          <h3 class="contact-info__title">
            {{ $t('opening.title') }}
          </h3>

          <div class="contact-info__content">
            <p>
              {{ $t('opening.beforeToday') }}<br>
              {{ $store.state.gaps[dateToday]['openingHours'] }}{{ $t('opening.afterToday') }}
            </p>
            <p>
              {{ $t('opening.beforeTomorrow') }}<br>
              {{ $store.state.gaps[dateTomorrow]['openingHours'] }}{{ $t('opening.afterTomorrow') }}
            </p>
          </div>
        </section>
      </div>

      <div class="grid__item">
        <section class="card contact-info__card">
          <h3 class="contact-info__title">
            {{ $t('location.title') }}
          </h3>

          <div class="contact-info__content">
            <address v-html="$t('location.address')" />
            <p>{{ $t('location.phone') }}</p>
          </div>

          <footer class="contact-info__footer">
            <button-group>
              <action-link :href="'mailto:' + $t('location.email.url')">
                {{ $t('location.email.text') }}
              </action-link>
              <action-link
                href="https://www.google.com/maps/place/Miniatur+Wunderland/"
                target="_blank"
              >
                {{ $t('location.directions') }}
              </action-link>
            </button-group>
          </footer>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import dateHelper from '../functions/dateHelper'

import actionLink from './actionLink.vue'
import buttonGroup from './buttonGroup.vue'

export default {
  name: 'CContactInfo',

  components: {
    actionLink,
    buttonGroup
  },

  computed: {
    dateToday () {
      return dateHelper.formatDate()
    },
    dateTomorrow () {
      return dateHelper.formatDate(dateHelper.dayAfter())
    }
  }
}
</script>

<i18n locale="en">
{
  "opening": {
    "title": "Opening Hours",
    "beforeToday": "Today:",
    "afterToday": " ",
    "beforeTomorrow": "Tomorrow: ",
    "afterTomorrow": " ",
    "ticketsLink": {
      "text": "Tickets",
      "url": "/booking"
    },
    "reservationsLink": {
      "text": "Reservations",
      "url": "/reservation"
    }
  },
  "location": {
    "title": "Where is the Miniatur Wunderland?",
    "address": "Kehrwieder 2, Block D<br>20457 Hamburg – Speicherstadt",
    "directions": "Directions",
    "phone": "Phone +49 40 3006800",
    "email": {
      "text": "Email",
      "url": "info@miniatur-wunderland.de"
    }
  }
}
</i18n>

<i18n locale="de">
{
  "opening": {
    "title": "Öffnungszeiten",
    "beforeToday": "Heute:",
    "afterToday": " Uhr",
    "beforeTomorrow": "Morgen: ",
    "afterTomorrow": " Uhr",
    "ticketsLink": {
      "text": "Tickets",
      "url": "/buchung"
    },
    "reservationsLink": {
      "text": "Reservierung",
      "url": "/reservierung"
    }
  },
  "location": {
    "title": "Wo ist das Miniatur Wunderland?",
    "address": "Kehrwieder 2, Block D<br>20457 Hamburg – Speicherstadt",
    "directions": "Anfahrt",
    "phone": "Tel. +49 40 3006800",
    "email": {
      "text": "E-Mail",
      "url": "info@miniatur-wunderland.de"
    }
  }
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.contact-info {
  @include vertical-spacing;
}

.contact-info__card {
  height: 100%;
}

.contact-info__title {
  margin-bottom: 1em;
}

.contact-info__content {
  flex-grow: 1;

  address {
    margin-bottom: 1em;
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
}

.contact-info__footer {
  margin-top: $gutter-sm;
}
</style>
